import { render } from "./IconEmail.vue?vue&type=template&id=5fd58962&scoped=true&ts=true"
import script from "./IconEmail.vue?vue&type=script&lang=ts"
export * from "./IconEmail.vue?vue&type=script&lang=ts"

import "./IconEmail.vue?vue&type=style&index=0&id=5fd58962&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd58962"]])

export default __exports__